import { AnyAction } from 'redux';
import { UPLOAD_TO_PMS_ACTIONS } from '../actions/index';
import { UploadToPMS } from '../types/state';

import produce from 'immer';

const initialState: UploadToPMS = {
  isOpen: false,
  isLoading: false,
  data: undefined,
  refreshFuncParam: undefined,
  type: '',
  offerUploadStatus: {
    newLeaseOfferUploadExecutionId: '',
    renewalOfferUploadExecutionId: '',
    newLeaseOfferUploadStatus: '',
    renewalOfferUploadStatus: '',
  },
  newLeaseUploadOfferLogs: undefined,
  renewalUploadOfferLogs: undefined,
};

const uploadToPMSReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case UPLOAD_TO_PMS_ACTIONS.OPEN: {
      return produce(state, (draft) => {
        draft.isOpen = true;
        draft.type = action.payload.type;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.CLOSE: {
      return produce(state, (draft) => {
        draft.isOpen = false;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.CLEAR: {
      return produce(state, (draft) => {
        draft.data = undefined;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.SET_NEW_LEASE_TASK_EXECUTION_STATUS: {
      return produce(state, (draft) => {
        draft.offerUploadStatus.newLeaseOfferUploadExecutionId =
          action.payload.ExecutionId || action.payload.taskExecutionId;
        if (action.payload.Status) {
          draft.offerUploadStatus.newLeaseOfferUploadStatus =
            action.payload.Status;
        }
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.SET_RENEWAL_TASK_EXECUTION_STATUS: {
      return produce(state, (draft) => {
        draft.offerUploadStatus.renewalOfferUploadExecutionId =
          action.payload.ExecutionId || action.payload.taskExecutionId;
        if (action.payload.Status) {
          draft.offerUploadStatus.renewalOfferUploadStatus =
            action.payload.Status;
        }
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.IS_LOADING: {
      return produce(state, (draft) => {
        draft.isLoading = action.payload.isLoading;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.SET_REFRESH_FUNC_PARAM: {
      return produce(state, (draft) => {
        draft.refreshFuncParam = action.payload.refreshFuncParam;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.FETCH: {
      return produce(state, (draft) => {
        const data = action.payload.data;

        if (data) {
          draft.data = data.map((item: any, index: number) => {
            let newItem = { ...item };
            newItem.id = index;
            return newItem;
          });
        }
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.SET_NEW_LEASE_UPLOAD_OFFER_LOGS: {
      return produce(state, (draft) => {
        draft.newLeaseUploadOfferLogs = action.payload;
      });
    }

    case UPLOAD_TO_PMS_ACTIONS.SET_RENEWAL_UPLOAD_OFFER_LOGS: {
      return produce(state, (draft) => {
        draft.renewalUploadOfferLogs = action.payload;
      });
    }

    default:
      return state;
  }
};

export default uploadToPMSReducer;
